/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum Kind {
  Value = 'VALUE',
  Min = 'MIN',
  Max = 'MAX'
}
